import {Base} from "@/api/Base"

export class ReportConfirm extends Base {
    path = "report/confirm"
}